module.exports = __webpack_public_path__ + "img/1440.cf40485f.jpg";